__turbopack_context__.v({
  "AddButton": "M_2XVa_AddButton",
  "CheckboxField": "M_2XVa_CheckboxField",
  "CheckboxLabel": "M_2XVa_CheckboxLabel",
  "CollapsibleContent": "M_2XVa_CollapsibleContent",
  "CollapsibleHeader": "M_2XVa_CollapsibleHeader",
  "CollapsibleSection": "M_2XVa_CollapsibleSection",
  "ColorDot": "M_2XVa_ColorDot",
  "Divider": "M_2XVa_Divider",
  "DragHandle": "M_2XVa_DragHandle",
  "DuplicateButton": "M_2XVa_DuplicateButton",
  "ExpandIcon": "M_2XVa_ExpandIcon",
  "Expanded": "M_2XVa_Expanded",
  "Field": "M_2XVa_Field",
  "FieldRow": "M_2XVa_FieldRow",
  "FieldRowHalf": "M_2XVa_FieldRowHalf",
  "HelpText": "M_2XVa_HelpText",
  "Input": "M_2XVa_Input",
  "Invalid": "M_2XVa_Invalid",
  "Label": "M_2XVa_Label",
  "RemoveButton": "M_2XVa_RemoveButton",
  "Root": "M_2XVa_Root",
  "SectionLabel": "M_2XVa_SectionLabel",
  "Select": "M_2XVa_Select",
  "SeriesContent": "M_2XVa_SeriesContent",
  "SeriesHeader": "M_2XVa_SeriesHeader",
  "SeriesItem": "M_2XVa_SeriesItem",
  "SeriesList": "M_2XVa_SeriesList",
  "SeriesName": "M_2XVa_SeriesName",
  "skeleton-loading": "M_2XVa_skeleton-loading",
});
